<template>
  <v-container fluid>
    <vue-headful title="Email" description="Online-Service Administration"/>
    <v-row>
      <v-col>
        <div class="pb-3">
          <h1 class="display-1" style="color:#d30228;">E-Mail</h1>
        </div>
      </v-col>
    </v-row>
    <!--    <v-divider></v-divider>-->
    <v-row class="mx-0" style="min-height: 40px;">
      <v-btn v-if="changed" dark @click="save">Speichern</v-btn>
      <v-btn v-if="changed" class="ml-3" @click="load">Abbrechen</v-btn>
    </v-row>
    <v-progress-linear v-if="loading" class="mr-10" indeterminate></v-progress-linear>
    <v-alert type="error" v-if="error">{{ reason }}</v-alert>
    <v-form>
      <v-simple-table>
        <tr>
          <td width="400px">
            <v-text-field v-model="settings_edited.smtp_server" label="SMTP Server"></v-text-field>
          </td>
          <td>
            Hostname oder IP des Mailservers
          </td>
        </tr>
        <tr>
          <td>
            <v-text-field v-model="settings_edited.smtp_port" label="SMTP Port" type="number"></v-text-field>
          </td>
          <td>
            Port am Mailserver, z.B. 25, 465 oder 587
          </td>
        </tr>
        <tr>
          <td>
            <v-text-field v-model="settings_edited.email" label="E-Mail-Adresse" :name="Math.random()"
                          :rules="emailRules"></v-text-field>
          </td>
          <td>
            E-Mail-Adresse für den Versand. Wird in den Mails auch als Antwortadresse (reply-to) eingestellt.
          </td>
        </tr>
        <tr>
          <td>
            <v-text-field v-model="settings_edited.email_user" label="Benutzername"
                          :name="Math.random()"></v-text-field>
          </td>
          <td>
            Benutzername des E-Mail-Accounts, mit dem Versendet werden soll (normalerweise unterschiedlich von der
            E-Mail-Adresse)
          </td>
        </tr>
        <tr>
          <td>
            <v-text-field v-model="settings_edited.email_pw" label="Passwort" type="password"
                          :name="Math.random()"></v-text-field>
          </td>
          <td>
            Passwort des E-Mail-Accounts, mit dem Versendet werden soll
          </td>
        </tr>
      </v-simple-table>
    </v-form>
    <v-divider class="my-5"></v-divider>
    <div style="width: 600px;">
      <h1 class="headline" style="color:#d30228;">Testmail</h1>
      <v-row>
        <v-text-field class="mx-3 my-3" v-model="testmail" label="E-Mail-Adresse" :rules="emailRules"></v-text-field>
        <v-btn class="ml-3 mt-5" @click="onSendTestMail" color="primary" :disabled="!isValidTestMail">Allgemein</v-btn>
        <v-btn class="ml-3 mt-5" @click="onSendTestReminder" color="primary" :disabled="!isValidTestMail">Reminder</v-btn>
      </v-row>
    </div>
    <v-divider class="my-5"></v-divider>
    <div class="py-3">
      <h1 class="headline" style="color:#d30228;">Email-Texte</h1>
      <v-simple-table class="mt-3 pb-3">
        <tr v-for="mailtext in mailtexts">
          <td>
            <span>{{ mailtext.beschreibung }}</span>
          </td>
          <td class="pb-1">
            <v-btn v-if="!mailtext.multiply" small class="mt-1" :to="'/service/email_editor/'+mailtext.id">Bearbeiten</v-btn>
            <v-btn v-else v-for="i in mailtext.multiply" small class="mt-1 mr-2" :to="'/service/email_editor/'+mailtext.id+'-'+i">{{i}}</v-btn>
          </td>
        </tr>
      </v-simple-table>
    </div>
  </v-container>
</template>

<script>
const SETTINGS_CONTEXT = "email";
export default {
  name: 'Service_Email',
  components: {},
  data() {
    return {
      settings: {},
      settings_edited: {},
      loading: false,
      reason: '',
      error: false,
      changed: false,
      testmail: '',
      emailRules: [
        v => !!v || 'Bitte ausfüllen',
        v => /.+@.+/.test(v) || 'Ungültige Email',
      ],
      mailtexts: [
        {id: "email-welcome-new-digi", beschreibung: "Begrüßungsmail neue Kunden",},
        {id: "email-welcome-exist-digi", beschreibung: "Begrüßungsmail Wiederholungskäufer",},
        {id: "email-activation", beschreibung: "Aktivierungsaufforderung",},
        {id: "email-welcome", beschreibung: "Begrüßungsmail nach Aktivierung",},
        {id: "email-welcome2", beschreibung: "Begrüßungsmail2",},
        {id: "email-recover", beschreibung: "Passwort zurücksetzen",},
        {id: "email-reminder", beschreibung: "Erinnerungsmail",},
        {id: "email-firstdays", beschreibung: "Newsletter 'First Days'", multiply:14 },
        {id: "email-wochenbericht", beschreibung: "Newsletter 'Wochenbericht'",},
        {id: "email-dranbleiben", beschreibung: "Newsletter 'Dranbleiben'",},
        {id: "email-jubilaeum", beschreibung: "Newsletter 'Jubiläum'",},
        {id: "email-variable", beschreibung: "Variabler Block",},
        {id: "email-streak-warning", beschreibung: "Streak-Warnung",},
      ],
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      this.$backend.get_settings(SETTINGS_CONTEXT, {onSuccess: this.onLoadSuccess, onError: this.onLoadError});
    },
    onLoadSuccess(data) {
      this.loading = false;
      this.settings = data;
      this.settings_edited = JSON.parse(JSON.stringify(data));
    },
    onLoadError(reason) {
      this.loading = false;
      this.settings = {};
      this.error = true;
      this.reason = reason;
    },
    save() {
      this.loading = true;
      this.$backend.set_settings(SETTINGS_CONTEXT, this.settings_edited, {
        onSuccess: this.onSaveSuccess,
        onError: this.onSaveError
      });
      this.load();
    },
    onSaveSuccess(data) {
      this.loading = false;
      this.settings = data;
      this.settings_edited = JSON.parse(JSON.stringify(data));
    },
    onSaveError(reason) {
      this.loading = false;
      this.error = true;
      this.reason = reason;
      this.load();
    },
    onSendTestMail() {
      this.$backend.send_test_email(this.testmail);
    },
    onSendTestReminder() {
      this.$backend.send_test_email(this.testmail, "email-reminder");
    },
  },
  computed: {
    isValidTestMail() {
      return this.testmail && /.+@.+/.test(this.testmail);
    },
  },
  watch: {
    settings_edited: {
      deep: true,
      handler(o, n) {
        this.changed = JSON.stringify(this.settings) !== JSON.stringify(this.settings_edited);
      }
    }
  }
}
</script>

<style scoped>
</style>
